<template>
  <div class="clpicker">
    <div class="msg">
      {{ $t("datapesquisa") }}
      <a @click="$emit('closePicker')"><i data-icon-name="ChromeClose" aria-hidden="true" class="ms-Icon root-43"></i></a>
    </div>
    <CalendarScroller 
      :startyear="2021"
      :endyear="2025"
      :cdate="currentweek"
      :limitYears="true"
      :selectionmode="true"
      :monthmode="selectedOption?.id == 3"
      @set-data="setData" />
  </div>
</template>


<script>
import { computed } from "vue";
import CalendarScroller from '@/components/calendarScroller/calendarScroller.vue';
import { useEventSearch } from "@/stores/eventSearch.ts";

export default {
  name: 'ListCalendarPicker',
  emits:["closePicker","setData","listFilterChange","isoncalendar"],
  props:["selectedOption","options","showPicker"],
  components:{
    CalendarScroller
  },
  setup(){
    const eventstore = useEventSearch();
    const currentweek = computed(()=>eventstore.selectedWeek);
    return {
      currentweek
    }

  },
  created(){
    this.$emit("isoncalendar");
  },
  beforeUnmount(){
    this.$emit("isoncalendar");
  },
  methods:{
    setData(data){
      this.$emit("setData",data);
      this.$emit("closePicker");
    }
  }
}
</script>

<style scoped>
.clpicker{
  background-color: white;
  z-index: 2;
  /*padding-top: 20px;*/
  /*padding-left: 15px;
  padding-right: 15px;*/
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 100px;
}

.msg{
  font-family: "Montserrat";
  justify-content: space-around;
  display: flex;
  background-color: black;
  padding-top: 10px;
  padding-bottom: 10px;
  color: white;
}

a{
  color: white;
}

/*
.msg{
  font-family: "Montserrat";
  justify-content: space-around;
  display: flex;
}*/
</style>